@let offersValue = offers();
@let showJobControlValue = showJobControl();

<form [formGroup]="form()" padding>
  @if (showSendAtKind()) {
    <rt-evaluation-send-at-kind-form-control
      [value]="sendAtKind()"
      [isSchedulerLink]="isSchedulerLink()"
      (valueChange)="sendAtKindChange.emit($event)"
      margin-bottom
    />
  }

  @if (showJobControlValue) {
    <rt-evaluation-job-field
      [control]="form().controls.offerId"
      [offers]="offersValue"
      [hasBox]="false"
      label="app.interview.job"
      margin-bottom
    />
  }

  <rt-evaluation-form-control
    [control]="form().controls.templateId"
    [groupedForms]="groupedTemplates()"
    [disabled]="!templatesLoaded()"
    margin-bottom
  />

  <div layout layout-horizontal>
    @if (showDueDate()) {
      <rt-evaluation-due-date-form-control
        [value]="timeData()"
        (valueChange)="timeDataChange.emit($event)"
        layout-flex-1
        margin-right-small
      />
    }
    @if (showRelativeDueDate()) {
      <rt-evaluation-relative-due-date-form-control
        [value]="dueDateConfig()"
        (valueChange)="dueDateConfigChange.emit($event)"
        layout-flex-1
        margin-right-small
      />
    }

    <rt-evaluation-admins-form-control
      [control]="form().controls.admins"
      [editable]="canViewCandidates()"
      (editAssignments)="editAssignments.emit()"
      layout-flex-1
    />
  </div>
</form>
